import React from 'react';

class Conf extends React.Component {
  render() {
    return <h1>Configurações</h1>;
  }
}

export default Conf;
